import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import classNames from 'classnames';


const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  bar: {
    backgroundColor: theme.palette.primary.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class WarningBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.timeout = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.trigger !== this.props.trigger){
      clearTimeout(this.timeout);
      this.setState({open: true});
      this.timeout = setTimeout(this.closeBar, 5000);
    }
  }

  closeBar = () => {
    clearTimeout(this.timeout);
    this.setState({ open: false });
  };

  render() {
    const { classes, content } = this.props;
    return (
      <div>
        <Snackbar
          ContentProps={{
            className: classes.bar
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.open}
          onClose={this.closeBar}
          message={
            <span className={classes.message}>
              <ErrorIcon className={classNames(classes.icon, classes.iconVariant)} />
              {content}
            </span>
          }
          action={[
            <IconButton
              key="close"
              color="inherit"
              className={classes.close}
              onClick={this.closeBar}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(WarningBar);


// WEBPACK FOOTER //
// ./src/components/WarningBar.js